import type { LeadRulesAggregation } from '@viq-admin/types';
import type { MetricTone } from '../batch/MetricCard';
import { LEAD_RULES_COPY } from './copy';

/**
 * The Total Notes tile (spec 2026-09-14 §3.4): green when every unsent lead of
 * this batch meets the company's notes minimum, red otherwise, neutral when the
 * company has no notes minimum or rules are off. Same in flag and block.
 */
export function notesTileState(
  leadRules: LeadRulesAggregation | null | undefined,
): { tone?: MetricTone; caption?: string } {
  if (!leadRules || leadRules.notesMin === null || leadRules.notesShortCount === null) return {};
  if (leadRules.notesShortCount === 0) {
    return { tone: 'success', caption: LEAD_RULES_COPY.notesTileOk };
  }
  return { tone: 'danger', caption: LEAD_RULES_COPY.notesTileShort(leadRules.notesShortCount) };
}
